import { Button } from 'antd';
import './quiz-form-buttons.css';
import { useQuizFormContext } from '../../hooks/quiz-form-context';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
const QuizFormButtons = ({
  pageType,
  saveFormData,
  resetFormData,
  nextPageClick,
  backPageClick,
  registerToSave,
  isLoggin,
  handleNextPageAction,
  downloadPdf
}) => {
  const { instance } = useMsal();
  const { isFormValuesSaved, setIsFormValuesSaved, setIsCongratulationsModalOpen } = useQuizFormContext()
  const redirectToLogin = () => {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  }
  const downloadPdfHandler = () => {
    showCongratulationsModal()
    downloadPdf()
  }
  function continueButtonHandler() {
    if (pageType == 'BasicDetails' || pageType == 'AdditionalDetails') {
      if (!handleNextPageAction()) return
      nextPageClick();
    }
  }

  async function saveFormValuesHandler() {
    if (pageType == 'AdditionalDetails' || pageType == 'Quiz3Review') {
      const isSaved = await saveFormData();
      if (isSaved) {
        setIsFormValuesSaved(true)
        if (pageType == 'Quiz3Review') {
          showCongratulationsModal()
        }
      }
    }
  }

  const showCongratulationsModal = () => {
    setIsCongratulationsModalOpen(true);
  };
  return (
    // <Row className="form-footer-container">
    <div className="form-footer-container">
      <div className="custom-row"></div>
      <div className="form-button-container ">
        <div className="button-container-reset">
          {
            pageType !== 'BasicDetails' && (
              <Button onClick={() => backPageClick()} className="back-button">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="arrow-left">
                    <path
                      id="Vector"
                      d="M21.0001 11.9999C21.0001 12.1988 20.9211 12.3896 20.7804 12.5303C20.6398 12.6709 20.449 12.7499 20.2501 12.7499H5.56041L11.0307 18.2193C11.1004 18.289 11.1557 18.3717 11.1934 18.4628C11.2311 18.5538 11.2505 18.6514 11.2505 18.7499C11.2505 18.8485 11.2311 18.9461 11.1934 19.0371C11.1557 19.1281 11.1004 19.2109 11.0307 19.2806C10.961 19.3502 10.8783 19.4055 10.7873 19.4432C10.6962 19.4809 10.5986 19.5003 10.5001 19.5003C10.4016 19.5003 10.304 19.4809 10.2129 19.4432C10.1219 19.4055 10.0392 19.3502 9.96948 19.2806L3.21948 12.5306C3.14974 12.4609 3.09443 12.3782 3.05668 12.2871C3.01894 12.1961 2.99951 12.0985 2.99951 11.9999C2.99951 11.9014 3.01894 11.8038 3.05668 11.7127C3.09443 11.6217 3.14974 11.539 3.21948 11.4693L9.96948 4.7193C10.1102 4.57857 10.3011 4.49951 10.5001 4.49951C10.6991 4.49951 10.89 4.57857 11.0307 4.7193C11.1715 4.86003 11.2505 5.05091 11.2505 5.24993C11.2505 5.44895 11.1715 5.63982 11.0307 5.78055L5.56041 11.2499H20.2501C20.449 11.2499 20.6398 11.3289 20.7804 11.4696C20.9211 11.6103 21.0001 11.801 21.0001 11.9999Z"
                      fill="#003E69"
                    />
                  </g>
                </svg>
                <span>{'Back'}</span>
              </Button>
            )
          }
          {(
            pageType == 'BasicDetails' || pageType == 'AdditionalDetails') && (
              <Button className="reset-button" type="text" onClick={() => resetFormData()}>
                Reset
              </Button>
            )}
        </div>
        <div className="button-container-save-continue">
          {
            isLoggin ?
              (
                <Button className="save-button" onClick={saveFormValuesHandler} disabled={pageType == 'BasicDetails'}>
                  {isFormValuesSaved ? (
                    <>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className='saved-icon'>
                        <g id="DownloadSimple">
                          <path d="M9.99974 15.172L19.1917 5.979L20.6067 7.393L9.99974 18L3.63574 11.636L5.04974 10.222L9.99974 15.172Z" fill="#003E69" />
                        </g>
                      </svg>
                      <span>Saved</span>
                    </>
                  ) : (
                    <span>Save</span>
                  )}
                </Button>
              ) : (
                <Button className="save-button" onClick={() => {
                  registerToSave();
                  redirectToLogin();
                }}>Register To Save</Button>
              )
          }
          {(
            pageType == 'BasicDetails' || pageType == 'AdditionalDetails') && (
              <Button className="continue-button" onClick={() => continueButtonHandler()}>
                <span>{'Continue'}</span>
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="arrow-right-line">
                    <path
                      id="Vector"
                      d="M16.672 11.9255L11.308 6.56146L12.722 5.14746L20.5 12.9255L12.722 20.7035L11.308 19.2895L16.672 13.9255H4.5V11.9255H16.672Z"
                      fill="#003E69"
                    />
                  </g>
                </svg>
              </Button>
            )}
          {pageType == 'Quiz3Review' && (
            <Button
              className="continue-button download-pdf-button"
              onClick={() => downloadPdfHandler()}
            >
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="DownloadSimple">
                  <path
                    id="Vector"
                    d="M21.875 15.1641V20.4141C21.875 20.9113 21.6775 21.3883 21.3258 21.7399C20.9742 22.0915 20.4973 22.2891 20 22.2891H5C4.50272 22.2891 4.02581 22.0915 3.67417 21.7399C3.32254 21.3883 3.125 20.9113 3.125 20.4141V15.1641C3.125 14.8657 3.24353 14.5795 3.4545 14.3686C3.66548 14.1576 3.95163 14.0391 4.25 14.0391C4.54837 14.0391 4.83452 14.1576 5.0455 14.3686C5.25647 14.5795 5.375 14.8657 5.375 15.1641V20.0391H19.625V15.1641C19.625 14.8657 19.7435 14.5795 19.9545 14.3686C20.1655 14.1576 20.4516 14.0391 20.75 14.0391C21.0484 14.0391 21.3345 14.1576 21.5455 14.3686C21.7565 14.5795 21.875 14.8657 21.875 15.1641ZM11.7041 15.96C11.8086 16.0649 11.9328 16.1481 12.0695 16.2049C12.2063 16.2617 12.3529 16.2909 12.5009 16.2909C12.649 16.2909 12.7956 16.2617 12.9324 16.2049C13.0691 16.1481 13.1933 16.0649 13.2978 15.96L17.0478 12.21C17.2592 11.9987 17.3779 11.712 17.3779 11.4131C17.3779 11.1142 17.2592 10.8276 17.0478 10.6163C16.8365 10.4049 16.5498 10.2862 16.2509 10.2862C15.9521 10.2862 15.6654 10.4049 15.4541 10.6163L13.625 12.4453V4.66406C13.625 4.36569 13.5065 4.07955 13.2955 3.86857C13.0845 3.65759 12.7984 3.53906 12.5 3.53906C12.2016 3.53906 11.9155 3.65759 11.7045 3.86857C11.4935 4.07955 11.375 4.36569 11.375 4.66406V12.4453L9.54594 10.6181C9.33459 10.4068 9.04795 10.288 8.74906 10.288C8.45018 10.288 8.16353 10.4068 7.95219 10.6181C7.74084 10.8295 7.62211 11.1161 7.62211 11.415C7.62211 11.7139 7.74084 12.0005 7.95219 12.2119L11.7041 15.96Z"
                    fill="#003E69"
                  />
                </g>
              </svg>
              <span>{'Download PDF'}</span>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
{/* </Row> */ }

export default QuizFormButtons;
